import { render } from "./TableOptions.vue?vue&type=template&id=3ca76528&ts=true"
import script from "./TableOptions.vue?vue&type=script&lang=ts"
export * from "./TableOptions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__